$(document).ready(function () {
	"use strict";

	//Моковые данные
	const resFormAjax = {
		dataForOneDay: {
			labels: [
				"00:00",
				"01:00",
				"02:00",
				"03:00",
				"04:00",
				"05:00",
				"06:00",
				"07:00",
				"08:00",
				"09:00",
				"10:00",
				"11:00",
				"12:00",
				"13:00",
				"14:00",
				"15:00",
				"16:00",
				"17:00",
				"18:00",
				"19:00",
				"20:00",
				"21:00",
				"22:00",
				"23:00",
				"24:00",
			],
			values: [
				118, 112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 118,
				112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 115,
			],
		},
		dataForThreeDay: {
			labels: [
				"00:00",
				"01:00",
				"02:00",
				"03:00",
				"04:00",
				"05:00",
				"06:00",
				"07:00",
				"08:00",
				"09:00",
				"10:00",
				"11:00",
				"12:00",
				"13:00",
				"14:00",
				"15:00",
				"16:00",
				"17:00",
				"18:00",
				"19:00",
				"20:00",
				"21:00",
				"22:00",
				"23:00",
				"00:00",
				"01:00",
				"02:00",
				"03:00",
				"04:00",
				"05:00",
				"06:00",
				"07:00",
				"08:00",
				"09:00",
				"10:00",
				"11:00",
				"12:00",
				"13:00",
				"14:00",
				"15:00",
				"16:00",
				"17:00",
				"18:00",
				"19:00",
				"20:00",
				"21:00",
				"22:00",
				"23:00",
				"00:00",
				"01:00",
				"02:00",
				"03:00",
				"04:00",
				"05:00",
				"06:00",
				"07:00",
				"08:00",
				"09:00",
				"10:00",
				"11:00",
				"12:00",
				"13:00",
				"14:00",
				"15:00",
				"16:00",
				"17:00",
				"18:00",
				"19:00",
				"20:00",
				"21:00",
				"22:00",
				"23:00",
				"00:00",
			],
			values: [
				118, 112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 118,
				112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 118, 112,
				115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 118, 112, 115,
				112, 105, 110, 100, 107, 103, 115, 123, 110, 118, 112, 115, 112,
				105, 110, 100, 107, 103, 115, 123, 110, 118, 112, 115, 112, 105,
				110, 100, 107, 103, 115, 123, 110,
			],
		},
		dataForWeek: {
			labels: ["1", "2", "3", "4", "5", "6", "7"],
			values: [118, 112, 115, 112, 105, 110, 100],
		},
		dataForTowWeek: {
			labels: [
				"1",
				"2",
				"3",
				"4",
				"5",
				"6",
				"7",
				"8",
				"9",
				"10",
				"11",
				"12",
				"13",
				"14",
			],
			values: [
				118, 112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 118,
				112,
			],
		},
		dataForMonth: {
			labels: [
				"1",
				"2",
				"3",
				"4",
				"5",
				"6",
				"7",
				"8",
				"9",
				"10",
				"11",
				"12",
				"13",
				"14",
				"15",
				"16",
				"17",
				"18",
				"19",
				"20",
				"21",
				"22",
				"23",
				"24",
				"25",
				"26",
				"27",
				"28",
				"29",
				"30",
			],
			values: [
				118, 112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 118,
				112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 118, 112,
				115, 112, 105, 110,
			],
		},
		dataForHalfYear: {
			labels: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь"],
			values: [118, 112, 115, 112, 105, 110],
		},
		dataForYear: {
			labels: [
				"Январь",
				"Февраль",
				"Март",
				"Апрель",
				"Май",
				"Июнь",
				"Август",
				"Сентябрь",
				"Октябрь",
				"Ноябрь",
				"Декабрь",
			],
			values: [
				118, 112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110,
			],
		},
		dataForTwoYear: {
			labels: [
				"Январь",
				"Февраль",
				"Март",
				"Апрель",
				"Май",
				"Июнь",
				"Август",
				"Сентябрь",
				"Октябрь",
				"Ноябрь",
				"Декабрь",
				"Январь",
				"Февраль",
				"Март",
				"Апрель",
				"Май",
				"Июнь",
				"Август",
				"Сентябрь",
				"Октябрь",
				"Ноябрь",
				"Декабрь",
			],
			values: [
				118, 112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 118,
				112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110,
			],
		},
		dataForThreeYear: {
			labels: [
				"Январь",
				"Февраль",
				"Март",
				"Апрель",
				"Май",
				"Июнь",
				"Август",
				"Сентябрь",
				"Октябрь",
				"Ноябрь",
				"Декабрь",
				"Январь",
				"Февраль",
				"Март",
				"Апрель",
				"Май",
				"Июнь",
				"Август",
				"Сентябрь",
				"Октябрь",
				"Ноябрь",
				"Декабрь",
				"Январь",
				"Февраль",
				"Март",
				"Апрель",
				"Май",
				"Июнь",
				"Август",
				"Сентябрь",
				"Октябрь",
				"Ноябрь",
				"Декабрь",
			],
			values: [
				118, 112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 118,
				112, 115, 112, 105, 110, 100, 107, 103, 115, 123, 110, 118, 112,
				115, 112, 105, 110, 100, 107, 103, 115, 123, 110,
			],
		},
		dataForAllYear: {
			labels: [
				"1-й год",
				"2-й год",
				"3-й год",
				"4-й год",
				"5-й год",
				"6-й год",
				"7-й год",
				"8-й год",
				"9-й год",
				"10 год",
			],
			values: [118, 112, 115, 112, 105, 110, 100, 107, 103, 115],
		},
	};
	let data = []
	let period = 3; //Кол-во отоброжаемых дат в период
	let profitabilityValue;

	//Получение данных по стоимости Юнита
	const portfolioName = window.location.href.split("/").pop();
	const portfolioNameCompare = {
		"egs-balanced": 1,
		"egs-moderately": 3,
		"egs-high": 2,
		"momentum": 4,
		"egs-low-regular": 7,
		"egs-balanced-regular": 6,
		"income-formula": 151,
		"currency-perspective": 477,
		"investments-in-yuan": 474
	};

	//Обновляет данные графика
	function requestChartData(period) {
		const unitCostPrice = $(".js-uc-price");
		const unitManagedFee = $(".js-managed-fee b");
		const todayDateNode = $('.unit-cost__today-date');
		const unitCostProfitability = $(".js-uc-profitability");
		const noDataHideenBlocks = $('.js-no-data');
		const isRandomPeriod = typeof period === "object" ? true : false;

		$.ajax({
			type: "GET",
			url: isRandomPeriod
				? `/managed-capital/get-portfolio-dynamic?portfolio=${portfolioNameCompare[portfolioName]}&from=${period.from}&to=${period.to}`
				: `/managed-capital/get-portfolio-dynamic?portfolio=${portfolioNameCompare[portfolioName]}&period=${period}`,
			success: function (params) {
				data = []
				let costValue = [];


				params.quotes.map((item) => {
					data.push(item.quotesDate);
					costValue.push(item.quote);
				});

				//Считаем дополнительную прибавку к диапазону графика, что бы он лежал примерно в центре
				const scalesForChart = Math.abs(((costValue[costValue.length - 1] - costValue[0]) * 0.9) === 0 ? 0.1 :  ((costValue[costValue.length - 1] - costValue[0]) * 0.9));

				// dateLabel.slice(0, 30).map((item, index) => {
				// 	dateLabel[index] = new Date(item)
				// })

				// let data = dataLabel
				//Обновляем график
				myChartValue.data.labels = data;
				myChartValue.data.datasets[0].data = costValue;
				myChartValue.options.scales.y.max = Math.max.apply(null, costValue) + scalesForChart;
				myChartValue.options.scales.y.min = Math.min.apply(null, costValue) - scalesForChart;
				// myChartValue.options.scales.x.ticks.callback();

				//Указываем на какую дату стоимость юнита
				todayDateNode.text(params.priceDate.split('-').reverse().join('.'));

				//Обновляем стоимость юнита
				unitCostPrice.html(params.price + " &#8381;");

				//Обновляем сноску
				unitManagedFee.html(params.managementFee + '%');

				//Обновляем доходность
				if (costValue.length === 0) {
					unitCostProfitability.html("нет данных");
					noDataHideenBlocks.hide();
				} else {
					profitabilityValue = (((costValue[costValue.length - 1] - costValue[0]) / costValue[0]) * 100).toFixed(2);
					unitCostProfitability.html(profitabilityValue + " %");
					noDataHideenBlocks.show();
				}
				myChartValue.update();
			},
			errors: function (errors) {
				console.log(errors);
			},
		});
	}

	if( portfolioName !== 'managed-capital'){
		requestChartData("1m");
	}

	//График

	// if (document.getElementById("myChartValue")) {
	const ctxValue = document.getElementById("myChartValue")?.getContext("2d");
		//Добавляет градиент для графика
	const gradientBg = ctxValue?.createLinearGradient(0, 0, 0, 400);
	gradientBg?.addColorStop(0, "rgba(0, 217, 0, 0.3)");
	gradientBg?.addColorStop(0.9, "rgba(246, 254, 246, 0.5)");

	//Создание нового графика
	const myChartValue = new Chart(ctxValue, {
		type: "line",
		data: {
			labels: resFormAjax.dataForYear.labels,
			datasets: [
				{
					label: "Стоимость юнита",
					borderColor: "#21A038",
					backgroundColor: gradientBg,
					data: resFormAjax.dataForYear.values,
					fill: true,
					tension: 0.2,
				},
			],
		},
		plugins: [ChartDataLabels],
		options: {
			responsive: true,
			plugins: {
				legend: {
					display: false,
				},
				datalabels: {
					formatter: function(value, context) {
						return profitabilityValue + ' %';
					},
					display: function(context) {
						return (context.dataIndex === context.dataset.data.length - 1)
					},
					backgroundColor: '#00d900',
					color: '#ffffff',
					// borderRadius: '10px',
					anchor: 'center',
					align: 'top',
					offset: 10,
				}
			},
			layout: {
				padding: 30
			},
			scales: {
				x: {
					// type: 'time',
					ticks: {
						callback: (value, index, values) => {
							if (period < 15) {
								if (index % period === 0) {
									return data[index]
								}
							}
							if (period === 15) {
								// console.log(333, data[index].slice(-2));
								if (data[index].slice(-2) === '01' || data[index].slice(-2) === '15') {
									return data[index]
								}
							}
							if (period === 30) {
								if (data[index].slice(-2) === '01') {
									return data[index]
								}
							}
						}
					}
					// time: {
					// 	unit: 'week'
					// }
				},
				y: {
					min: 80,
					max: 143,
				},
			},
		},
	});

	//Добавление маски для ввода даты в inputs
	const inputDateNode = $(".cost-chart__input-interval");

	inputDateNode.each(function () {
		$(this).inputmask("99.99.9999");
	});

	//Смена данных на графике в зависимости от периода
	const radioInputPeriod = $(".radiobutton-calc__input");

	radioInputPeriod.on("change", function () {
		switch ($(this).val()) {
			// case "1":
			// 	myChartValue.data.labels = resFormAjax.dataForOneDay.labels;
			// 	myChartValue.data.datasets[0].data =
			// 		resFormAjax.dataForOneDay.values;
			// 	myChartValue.options.scales.y.max =
			// 		Math.max.apply(null, resFormAjax.dataForOneDay.values) + 20;
			// 	myChartValue.options.scales.y.min =
			// 		Math.min.apply(null, resFormAjax.dataForOneDay.values) - 20;
			// 	myChartValue.update();
			// 	break;
			case "3":
				period = 1
				requestChartData("3d");
				break;
			case "7":
				period = 1
				requestChartData("1w");
				break;
			case "21":
				period = 2
				requestChartData("3w");
				break;
			case "30":
				period = 3
				requestChartData("1m");
				break;
			case "183":
				period = 15
				requestChartData("6m");
				break;
			case "365":
				period = 30
				requestChartData("1y");
				break;
			/* case "730":
				myChartValue.data.labels = resFormAjax.dataForTwoYear.labels;
				myChartValue.data.datasets[0].data =
					resFormAjax.dataForTwoYear.values;
				myChartValue.options.scales.y.max =
					Math.max.apply(null, resFormAjax.dataForTwoYear.values) +
					20;
				myChartValue.options.scales.y.min =
					Math.min.apply(null, resFormAjax.dataForTwoYear.values) -
					20;
				myChartValue.update();
				break; */
			/* case "1095":
				myChartValue.data.labels = resFormAjax.dataForThreeYear.labels;
				myChartValue.data.datasets[0].data =
					resFormAjax.dataForThreeYear.values;
				myChartValue.options.scales.y.max =
					Math.max.apply(null, resFormAjax.dataForThreeYear.values) +
					20;
				myChartValue.options.scales.y.min =
					Math.min.apply(null, resFormAjax.dataForThreeYear.values) -
					20;
				myChartValue.update();
				break; */
			/* case "0":
				myChartValue.data.labels = resFormAjax.dataForAllYear.labels;
				myChartValue.data.datasets[0].data =
					resFormAjax.dataForAllYear.values;
				myChartValue.options.scales.y.max =
					Math.max.apply(null, resFormAjax.dataForAllYear.values) +
					20;
				myChartValue.options.scales.y.min =
					Math.min.apply(null, resFormAjax.dataForAllYear.values) -
					20;
				myChartValue.update();
				break; */
			default:
				console.log(222, "365");
		}
	});

	function updateInterval() {
		const inputFrom = $(".cost-chart__input-interval--from");
		const inputTo = $(".cost-chart__input-interval--to");
		const randomPeriod = {};

		if (inputFrom.inputmask("isComplete") && inputTo.inputmask("isComplete")) {
			randomPeriod.from = inputFrom.val().split(".").reverse().join("-");
			randomPeriod.to = inputTo.val().split(".").reverse().join("-");

			requestChartData(randomPeriod);
		}
	}

	//Смена данных на графике в зависимости от введных дат в инпуты
	inputDateNode.on("input", function () {
		updateInterval();
	});

	//Добавляет дата пикер
	inputDateNode.datepicker({
		clearButton: true,
		onSelect(formattedDate, date, inst) {
			inst.hide();
			updateInterval();
		},
	});
	// }
});
